<tran-ui-secondary-navigation [navigationItems]="secondaryNavItems" />

<tran-page-hero
    backgroundImage="/assets/images/background_home.png"
    backgroundPosition="center top"
    eyebrow="home.hero.eyebrow"
    titleKey="home.hero.title"
    description="home.hero.description"
    ctaLabel="home.hero.cta"
    ctaLink="home.hero.cta-link"
    [showOverlay]="false"
/>

<tran-customer-home-tile-section id="overview" />

<tran-customer-home-clustered-tiles-section id="about" />

<tran-quote-section
    backgroundImage="/assets/images/people-looking-at-graph-on-display.png"
    image="/assets/images/judith_wiese.jpg"
    imageAlt="Judith Wiese, Chief People and Sustainability Officer"
    quote="home.quote.text"
    author="home.quote.author"
    [showOverlay]="true"
    [noLeftSpacing]="true"
/>

<tran-step-section
    id="how-to-apply"
    eyebrow="home.steps-to-transformation-project.eyebrow"
    titleKey="home.steps-to-transformation-project.title"
    boldTitle="home.steps-to-transformation-project.bold-title"
    [steps]="steps"
>
    <div select="[slot=below]" class="pt-20">
        <tran-primary-button
            [label]="'home.steps-to-transformation-project.cta-label' | translate"
            href="/faq"
        />
    </div>
</tran-step-section>

<tran-quote-section
    backgroundImage="/assets/images/people-taking-notes-in-stand-up.png"
    image="/assets/images/tobias_baeumler.png"
    imageAlt="Tobias Bäumler"
    imagePosition="right"
    quote="home.quote2.text"
    author="home.quote2.author"
    [showOverlay]="true"
    [noRightSpacing]="true"
/>

<tran-customer-home-dates-and-deadlines-table id="dates-deadlines" />

<tran-link-section id="tools-resources" titleKey="home.further-links.title" [links]="furtherLinks" />
